exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "a[data-v-5d4afcda]{text-decoration:none}.blue-color[data-v-5d4afcda]{color:#589df8}", "", {"version":3,"sources":["/workspace/src/views/task/pages/TaskDetail.vue"],"names":[],"mappings":"AACA,mBAAmB,oBAAoB,CACtC,AACD,6BAA6B,aAAa,CACzC","file":"TaskDetail.vue","sourcesContent":["\na[data-v-5d4afcda]{text-decoration:none\n}\n.blue-color[data-v-5d4afcda]{color:#589df8\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d4afcda","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/task/pages/TaskDetail.vue
// module id = 5515
// module chunks = 255